
import { Box, Container, Typography, Button, Skeleton } from "@mui/material";
import CardNoticiaCaroussel from './cardNoticiaCaroussel';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'; 
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import 'swiper/css';
import 'swiper/css/pagination';

export default function CarousselNoticias() {
  const navigate = useNavigate()
  const [noticias, setNoticias] = useState('')

  useEffect(() => {
    api.get(`/noticias?perPage=10`)
      .then(response => {
        // console.log(response)
        setNoticias(response.data.noticias);
        localStorage.setItem('noticiaId', response.data.noticias[0]?._id || '');
      }).catch(error => {
        // console.log(error)
      })
  }, [])

  function SkeletonCard() {
    return (
      <Box>
        <Box className="tw-w-[210px] tw-mr-2 tw-my-5 tw-h-[350px]">
          <Skeleton animation="wave" variant="rectangular" width={210} className="tw-h-[200px]" />
          <Box className="tw-pt-2">
            <Skeleton animation="wave" />
            <Skeleton animation="wave" width="60%" />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <div className="tw-mt-[70px] tw-mb-[20px]">

      <Container>

        <Typography align="center" variant="h1" className="tw-m-4 tw-text-[25px] tw-font-bold">
          NOTÍCIAS
        </Typography>

        <Swiper
          breakpoints={{
            // Configurações quando a largura da tela for >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            // Configurações quando a largura da tela for >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            // Configurações quando a largura da tela for >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
            // ... Adicione mais breakpoints conforme necessário
          }
          pagination={{
            clickable: true,
          }}

          modules={[Pagination]}
          className="mySwiper"
        >
          {noticias ?
            noticias.map((noticia) => (
              <SwiperSlide key={noticia._id}>
                <CardNoticiaCaroussel noticia={noticia} />
              </SwiperSlide>
            ))
            :
            [...Array(10)].map((_, index) => (
              <SwiperSlide key={index}>
                <SkeletonCard />
              </SwiperSlide>
            ))
          }
        </Swiper>

        <Box marginTop={3} className="md:tw-hidden">
          <Button onClick={() => navigate(`/view-noticia/${localStorage.getItem('noticiaId')}`)} variant='outiline' fullWidth className="tw-bg-[#85287e] tw-text-white">
            Ver mais notícias
          </Button>
        </Box>
      </Container>
    </div>
  )
}